export default __webpack_public_path__ + "static/media/Gulmarg3.2c0af5fe.jpg";